
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mp4-to-mp3-converter",
      function () {
        return require("private-next-pages/mp4-to-mp3-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mp4-to-mp3-converter"])
      });
    }
  